import { call, put, takeEvery } from "redux-saga/effects";
import { sortFavoriteApps } from "store/api/organization/applicationsSettingsGet/applicationsSettingsGetSaga";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/applicationsGet";
import { modifyApplicationDefaultIconUrl } from "@p81-common/shell-core-js";

function* applicationsGet(action) {
  try {
    let { data } = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      "applications"
    );

    let { favoriteApplications = [] } = data.relationships;

    data.applications = data.applications.filter((app) => {
      if (app.enabled) {
        app.isFavorite = favoriteApplications.includes(app.id);
        return true;
      }
      return false;
    });

    data.applications = sortFavoriteApps(
      data.applications,
      favoriteApplications
    );

    data.applications.forEach((app) => {
      modifyApplicationDefaultIconUrl(app);
    });

    yield put(actions.requestSuccess(data));
  } catch (e) {
    yield put(actions.requestFailure(e));
  }
}

function* saga() {
  yield takeEvery(actions.APPLICATIONS_GET_REQUEST, applicationsGet);
}

export default saga;
